import LegalPage from "./LegalPage";

const TERMS_SECTIONS = [
  {
    heading: "Acceptance of terms",
    body: [
      "By accessing or using this website you accept these Terms of Use. If you do not agree, please do not use this site.",
    ],
  },
  {
    heading: "Nature of the website",
    body: [
      "This website is the public marketing presence of Bigibila Consultancy / BIGIBILA SYSTEMS™. It explains our governance architecture products and how to engage with us. It is not a database of culture, it is not legal advice, and it does not replace Aboriginal authority or cultural decision-making.",
      "The demo dashboard contains fictional sample data only. No real community, cultural, client, family or sensitive information is stored in the demo environment.",
    ],
  },
  {
    heading: "Intellectual property",
    body: [
      "All content on this site — including written copy, visual design, navigation language, the Girribal learning gate, the Bigibila Advisory Method™, Lore-Led Architecture™, the Aboriginal Governance Architecture Model™, AGAM Toolkit™, Lore-Gate™ and the BIG-series toolkit codes — is the intellectual property of Bigibila Consultancy under background IP terms.",
      "Nothing on this site may be copied, redistributed, used as the basis for derivative work, or used to train artificial intelligence systems without prior written agreement.",
    ],
  },
  {
    heading: "No advisory relationship",
    body: [
      "Browsing this website does not create a client, advisory or contractual relationship. A formal engagement, scope and agreement is required before any advisory work begins.",
    ],
  },
  {
    heading: "Pricing",
    body: [
      "Pricing shown on the Licensing page is published from-pricing. Final pricing is subject to discovery, scope of work, governance complexity and risk profile, and is provided by formal proposal.",
    ],
  },
  {
    heading: "Limitation of liability",
    body: [
      "We do our best to keep this website accurate and up to date. We make no warranty that the content is complete, current or fit for any particular purpose. To the extent permitted by law we accept no liability for any loss arising from reliance on the website alone.",
    ],
  },
  {
    heading: "Governing law",
    body: [
      "These terms are governed by the laws of New South Wales, Australia, and the Commonwealth of Australia.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms of Use"
      lastUpdated="DRAFT — Feb 2026"
      sections={TERMS_SECTIONS}
    />
  );
}
